import React, { useEffect, useState } from "react";
import ResultsTable from "./../../results/ResultTable";
import { GetCourseSchedule } from "../API";
import HomeScheduleItem from "./HomeScheduleItem";
export default function Home(props) {
  const [data, setData] = useState([]);
  useEffect(() => {
    GetCourseSchedule(props.match.params.crsnum).then(data => {
      console.log(data);
      setData(data);
    });
  },[props.match.params.crsnum]  );
  return (
    <div>
      <div class="card card-bottom-tabs m-t-10">
        <div class="card-block">
          <h4 class="card-title m-t-0">Course Results</h4>
          <ResultsTable crsnum={props.match.params.crsnum} />
        </div>
      </div>

      <div class="card card-bottom-tabs m-t-10">
        <div class="card-block">
          <h4 class="card-title m-t-0">Course Schedule</h4>
          <ul class="timeline">
            {data.map((item, index) => (
              <HomeScheduleItem key={item.from + item.dayName} {...item} />
            ))}{" "}
          </ul>
        </div>
      </div>

      {/* <div class="card card-bottom-tabs m-t-10">
        <div class="card-block">
          <h4 class="card-title m-t-0">Course Description</h4>

          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum
            pulvinar lobortis ullamcorper. Pellentesque et enim sit amet ligula
            facilisis accumsan. Proin mollis finibus felis sed feugiat. Aliquam
            sem nibh, consectetur quis diam at, molestie congue nunc.
            Pellentesque tincidunt metus urna, a laoreet sem imperdiet et.
            Pellentesque vitae turpis nec eros fermentum pretium id et tellus.
            Phasellus pulvinar auctor mollis. Sed lacinia sem ligula, non
            dapibus justo molestie non. Integer dictum orci eu euismod
            venenatis. Quisque ac nibh tortor. Nulla pellentesque pretium dolor,
            a dignissim ligula lobortis nec. Fusce ac scelerisque nunc, at
            mattis dui. Aliquam facilisis orci semper nisi ullamcorper
            vestibulum. Pellentesque aliquet neque efficitur convallis mattis.
            Vestibulum eu augue vitae mauris molestie mollis vel a urna.
            Phasellus commodo felis ut nibh feugiat facilisis.
          </p>
          <p>
            Pellentesque eleifend felis et magna faucibus, a mattis nulla porta.
            Etiam risus nibh, finibus at diam id, convallis auctor dui. Maecenas
            blandit eget mauris vitae condimentum. Maecenas vitae quam diam.
            Aliquam faucibus eros mauris, eu elementum nunc tristique vitae. Nam
            mollis, odio a ultricies mattis, ipsum ante blandit massa, vel
            tempus libero tellus quis lorem. Duis mi nisl, vehicula a sapien in,
            pulvinar fringilla nisi. Aenean ut neque ligula.
          </p>
        </div>
      </div>

      <div class="card card-bottom-tabs m-t-10">
        <div class="card-block">
          <h4 class="card-title m-t-0">Course Syllabus</h4>

          <ol>
            <li>
              <span class="f-w-700">
                Chapter One: Aliquam iaculis erat et eros lacinia, quis
                condimentum ex efficitur
              </span>
              <ul>
                <li>
                  Vestibulum sagittis nisl vitae ex finibus, at dictum orci
                  venenatis.
                </li>
                <li>
                  Vestibulum eget turpis ac orci finibus iaculis nec semper
                  ligula.
                </li>
                <li>
                  Morbi vulputate mi eu nisl sagittis, id facilisis arcu
                  gravida.
                </li>
                <li>
                  Nunc accumsan enim at nulla sollicitudin, in volutpat neque
                  malesuada.
                </li>
                <li>
                  Phasellus condimentum neque id sem facilisis, eu viverra leo
                  viverra.
                </li>
              </ul>
            </li>
            <li>
              <span class="f-w-700">
                Chapter Two: Phasellus condimentum neque id sem facilisis, eu
                viverra leo viverra.
              </span>
              <ul>
                <li>
                  Vestibulum sagittis nisl vitae ex finibus, at dictum orci
                  venenatis.
                </li>
                <li>
                  Vestibulum eget turpis ac orci finibus iaculis nec semper
                  ligula.
                </li>
                <li>
                  Morbi vulputate mi eu nisl sagittis, id facilisis arcu
                  gravida.
                </li>
                <li>
                  Nunc accumsan enim at nulla sollicitudin, in volutpat neque
                  malesuada.
                </li>
                <li>
                  Phasellus condimentum neque id sem facilisis, eu viverra leo
                  viverra.
                </li>
              </ul>
            </li>
            <li>
              <span class="f-w-700">
                Chapter Three: Nunc accumsan enim at nulla sollicitudin, in
                volutpat neque malesuada
              </span>
              <ul>
                <li>
                  Vestibulum sagittis nisl vitae ex finibus, at dictum orci
                  venenatis.
                </li>
                <li>
                  Vestibulum eget turpis ac orci finibus iaculis nec semper
                  ligula.
                </li>
                <li>
                  Morbi vulputate mi eu nisl sagittis, id facilisis arcu
                  gravida.
                </li>
                <li>
                  Nunc accumsan enim at nulla sollicitudin, in volutpat neque
                  malesuada.
                </li>
                <li>
                  Phasellus condimentum neque id sem facilisis, eu viverra leo
                  viverra.
                </li>
              </ul>
            </li>
            <li>
              <span class="f-w-700">
                Chapter Four: Morbi vulputate mi eu nisl sagittis, id facilisis
                arcu gravida
              </span>
              <ul>
                <li>
                  Vestibulum sagittis nisl vitae ex finibus, at dictum orci
                  venenatis.
                </li>
                <li>
                  Vestibulum eget turpis ac orci finibus iaculis nec semper
                  ligula.
                </li>
                <li>
                  Morbi vulputate mi eu nisl sagittis, id facilisis arcu
                  gravida.
                </li>
                <li>
                  Nunc accumsan enim at nulla sollicitudin, in volutpat neque
                  malesuada.
                </li>
                <li>
                  Phasellus condimentum neque id sem facilisis, eu viverra leo
                  viverra.
                </li>
              </ul>
            </li>
            <li>
              <span class="f-w-700">
                Chapter Five: Vestibulum eget turpis ac orci finibus iaculis nec
                semper ligula
              </span>
              <ul>
                <li>
                  Vestibulum sagittis nisl vitae ex finibus, at dictum orci
                  venenatis.
                </li>
                <li>
                  Vestibulum eget turpis ac orci finibus iaculis nec semper
                  ligula.
                </li>
                <li>
                  Morbi vulputate mi eu nisl sagittis, id facilisis arcu
                  gravida.
                </li>
                <li>
                  Nunc accumsan enim at nulla sollicitudin, in volutpat neque
                  malesuada.
                </li>
                <li>
                  Phasellus condimentum neque id sem facilisis, eu viverra leo
                  viverra.
                </li>
              </ul>
            </li>
            <li>
              <span class="f-w-700">
                Chapter Six: Aliquam iaculis erat et eros lacinia, quis
                condimentum ex efficitur
              </span>
              <ul>
                <li>
                  Vestibulum sagittis nisl vitae ex finibus, at dictum orci
                  venenatis.
                </li>
                <li>
                  Vestibulum eget turpis ac orci finibus iaculis nec semper
                  ligula.
                </li>
                <li>
                  Morbi vulputate mi eu nisl sagittis, id facilisis arcu
                  gravida.
                </li>
                <li>
                  Nunc accumsan enim at nulla sollicitudin, in volutpat neque
                  malesuada.
                </li>
                <li>
                  Phasellus condimentum neque id sem facilisis, eu viverra leo
                  viverra.
                </li>
              </ul>
            </li>
            <li>
              <span class="f-w-700">
                Chapter Seven: Phasellus condimentum neque id sem facilisis, eu
                viverra leo viverra
              </span>
              <ul>
                <li>
                  Vestibulum sagittis nisl vitae ex finibus, at dictum orci
                  venenatis.
                </li>
                <li>
                  Vestibulum eget turpis ac orci finibus iaculis nec semper
                  ligula.
                </li>
                <li>
                  Morbi vulputate mi eu nisl sagittis, id facilisis arcu
                  gravida.
                </li>
                <li>
                  Nunc accumsan enim at nulla sollicitudin, in volutpat neque
                  malesuada.
                </li>
                <li>
                  Phasellus condimentum neque id sem facilisis, eu viverra leo
                  viverra.
                </li>
              </ul>
            </li>
          </ol>
        </div>
      </div> */}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/course/Home/Home.js